module.exports = __webpack_public_path__ + "img/p-three-step-07.fcffc980.png";